import { render, staticRenderFns } from "./BecomeCustomer.vue?vue&type=template&id=710d209e&scoped=true&"
import script from "./BecomeCustomer.vue?vue&type=script&lang=js&"
export * from "./BecomeCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710d209e",
  null
  
)

export default component.exports